import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-for-sale',
  templateUrl: './for-sale.component.html',
  styleUrls: ['./for-sale.component.scss']
})
export class ForSaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
